import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
import { Apis } from '../../core/apis';
import { LoginRequest } from '../../models/request/login-request';
import { TokenAndRefreshToken } from '../../models/tokenandrefreshtoken.model';
import { ProfileResponseModel } from '../../models/profile.model';

const API_LOGIN_URL = Apis.Login;
const API_USER_ME_URL = Apis.me;

@Injectable({
  providedIn: 'root',
})
export class LoginService implements OnDestroy {
  callbackResponseForUser = new Subject();

  constructor(private http: HttpClient) {}

  login(data: LoginRequest): Observable<TokenAndRefreshToken> {
    return this.http.post<TokenAndRefreshToken>(API_LOGIN_URL, data);
  }

  user(): Observable<ProfileResponseModel> {
    return this.http.post<any>(API_USER_ME_URL, {
      userId: '',
      apiKey: '',
    });
  }

  updateUser(val: any) {
    this.callbackResponseForUser.next(val);
  }

  ngOnDestroy() {}
}
